const USER_BADGE_TYPES = {
    PREFERRED: 'preferred',
    STAFF: 'staff',
    VERIFIED: 'verified',
};

Object.freeze(USER_BADGE_TYPES);

export default USER_BADGE_TYPES;
